import Toasts from "views/components/Toasts";

const RootToasts = ({ isSticky }) => (
	<div className={`root-toasts ${!isSticky ? "fixed-top" : ""}`}>
		<div className="container position-relative">
			<Toasts />
		</div>
	</div>
);

export default RootToasts;
